import { EventCardPromoted } from '@eventbrite/event-renderer';
import { gettext } from '@eventbrite/i18n';
import React from 'react';
import { useServerEnrolledStatsigExperiment } from '../../../context/experiments';
import {
    EventCardPromotedLabelExperiment,
    EventCardPromotedLabelExperimentValues,
} from '../../../types';

export function EventCardExperimentalPromotedLabel() {
    const { variant: eventCardLabelExperiment } =
        useServerEnrolledStatsigExperiment({
            name: EventCardPromotedLabelExperiment.name,
            paramName: EventCardPromotedLabelExperiment.paramName,
            defaultValue: EventCardPromotedLabelExperiment.values.control,
        });

    const label = getPromotedEventLabel(eventCardLabelExperiment);

    return <EventCardPromoted isPromoted label={label} />;
}

function getPromotedEventLabel(
    eventCardLabelExperiment: EventCardPromotedLabelExperimentValues,
) {
    switch (eventCardLabelExperiment) {
        case EventCardPromotedLabelExperimentValues.sponsored:
            return gettext('Sponsored').toString();
        case EventCardPromotedLabelExperimentValues.ad:
            return gettext('Ad').toString();

        case EventCardPromotedLabelExperimentValues.control:
        default:
            return undefined;
    }
}
